'use es6';

import { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import UIIllustration from 'UIComponents/image/UIIllustration';
import FormattedMessage from 'I18n/components/FormattedMessage';
import H2 from 'UIComponents/elements/headings/H2';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const EmptyStateWrapper = styled.div.withConfig({
  displayName: "EmptyCustomSectionColumn__EmptyStateWrapper",
  componentId: "sc-1l5az89-0"
})([".hs-private.hs-private.hs-private &{display:flex;flex-direction:column;align-items:center;text-align:center;margin-top:48px;}"]);
const DEFAULT_NO_RESULTS_MESSAGE_YAML_KEY = 'addSectionPanel.customSections.noCustomSectionsTitle';
class EmptyCustomSectionColumn extends Component {
  renderTitle(titleText = DEFAULT_NO_RESULTS_MESSAGE_YAML_KEY) {
    const shouldDisplayTitleAsHeader = Boolean(this.props.message);
    const formattedTitle = /*#__PURE__*/_jsx(FormattedMessage, {
      message: titleText,
      options: {
        searchTerm: this.props.searchQuery
      }
    });
    return /*#__PURE__*/_jsx("div", {
      className: "m-top-4",
      children: shouldDisplayTitleAsHeader ? /*#__PURE__*/_jsx(H2, {
        className: "m-top-4",
        children: formattedTitle
      }) : formattedTitle
    });
  }
  render() {
    const {
      message,
      title
    } = this.props;
    return /*#__PURE__*/_jsx(EmptyStateWrapper, {
      children: /*#__PURE__*/_jsxs("div", {
        style: {
          width: 350
        },
        children: [/*#__PURE__*/_jsx(UIIllustration, {
          name: "empty-state-charts",
          width: "60%"
        }), this.renderTitle(title), message]
      })
    });
  }
}
EmptyCustomSectionColumn.propTypes = {
  message: PropTypes.node.isRequired,
  title: PropTypes.string,
  searchQuery: PropTypes.string
};
export default EmptyCustomSectionColumn;